import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchFittingSizes, createFittingSize, deleteFittingSize, updateFittingSize, checkFittingSizeExist } from '../../common/jsonstore';
import { FittingSize } from '../../common/model';
import { AppState } from '../../redux/store/rootReducer';
import { AppDispatch } from '../../redux/store/store';
import { isTokenExpired } from '../../services/authenticationService';
import { signOut } from '../../services/localStorage';
import { handleError } from '../../services/messageApiService';

export interface IAuthentication {
    FittingSize: FittingSize[];
    success: boolean;
    success_: any;
    isProcessingComplete: boolean;
}
const initialState: IAuthentication = { FittingSize: [], success: false, success_: {}, isProcessingComplete: false };

const FittingSizeSlice = createSlice({
    name: 'FittingSizes',
    initialState,
    reducers: {
        receiveFittingSizes: (state, action: PayloadAction<any>) => {
            return {
                ...state,
                FittingSize: action.payload,
                isProcessingComplete: false
            };
        },
        receiveFittingSize: (state, action: PayloadAction<any>) => {
            return {
                ...state,
                FittingSize: action.payload,
                isProcessingComplete: false
            };
        },
        success: (state, action: PayloadAction<any>) => {
            return {
                ...state,
                success: action.payload,
                isProcessingComplete: true
            };
        },
        success_: (state, action: PayloadAction<any>) => {
            return {
                ...state,
                success_: action.payload
            };
        }
    }
});

export const checkDataExist = (data: FittingSize, id: number): any => async (dispatch: AppDispatch) => {
    if (isTokenExpired()) {
        const res: any = await checkFittingSizeExist(data).then((resp: any) => {
            const result = resp.filter((item: any) => item.id !== id);
            if (result.length > 0) {
                dispatch(FittingSizeSlice.actions.success(false))
            } else {
                dispatch(FittingSizeSlice.actions.success(true))
            }
        }).catch(err => {
            if (err?.response?.data?.message?.includes("access token")) {
                handleError(err.response.data.message);
                setTimeout(() => { return signOut(); }, 500);
            }
            else {
                let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Internal Server Error';
                handleError(msg);
            }
        })
    } else {
        handleError('Token is expired');
        setTimeout(() => { return signOut(); }, 500);
    }
}

export const loadFittingSizes = (): any => async (dispatch: AppDispatch) => {
    if (isTokenExpired()) {
        const FittingSizes = await fetchFittingSizes().then((res: any) => {
            dispatch(FittingSizeSlice.actions.receiveFittingSizes(res))
        }).catch(err => {
            if (err?.response?.data?.message?.includes("access token")) {
                handleError(err.response.data.message);
                setTimeout(() => { return signOut(); }, 500);
            } else {
                let msg = (err?.response?.data?.mdg) ? err?.response?.data?.mdg : 'Connection Size Not loaded';
                handleError(msg);
            }
        })
    } else {
        handleError('Token is expired');
        setTimeout(() => { return signOut(); }, 500);
    }
}

export const addFittingSize = (newFittingSize: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
    if (isTokenExpired()) {
        const resp = await createFittingSize(newFittingSize).then((res: any) => {
            dispatch(FittingSizeSlice.actions.receiveFittingSize([...getState().FittingSizes.FittingSize, res]));
            dispatch(FittingSizeSlice.actions.success_({ 'sts': true, data: 'Connection Size added successfully' }));
        }).catch(err => {
            if (err?.response?.data?.message?.includes("access token")) {
                handleError(err.response.data.message);
                setTimeout(() => { return signOut(); }, 500);
            } else {
                let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Connection Size not added ';
                dispatch(FittingSizeSlice.actions.success_({ 'sts': false, data: msg }));
            }
        })
    } else {
        handleError('Token is expired');
        setTimeout(() => { return signOut(); }, 500);
    }
}

export const modifyFittingSize = (newFittingSize: FittingSize, id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
    if (isTokenExpired()) {
        const respp = await updateFittingSize(newFittingSize, id).then((res: any) => {
            const updatedFittingSizes = getState().FittingSizes.FittingSize.map(el => (el.id === id ? res : el))
            dispatch(FittingSizeSlice.actions.receiveFittingSizes(updatedFittingSizes));
            dispatch(FittingSizeSlice.actions.success_({ 'sts': true, data: 'Connection Size updated successfully' }));
        }).catch(err => {
            if (err?.response?.data?.message?.includes("access token")) {
                handleError(err.response.data.message);
                setTimeout(() => { return signOut(); }, 500);
            } else {
                let msg = (err?.response?.data?.msg) ? err?.response?.data?.msg : 'Connection Size not updated ';
                dispatch(FittingSizeSlice.actions.success_({ 'sts': false, data: msg }));
            }
        })
    } else {
        handleError('Token is expired');
        setTimeout(() => { return signOut(); }, 500);
    }
}

export const removeFittingSize = (id: number): any => async (dispatch: AppDispatch, getState: () => AppState) => {
    if (isTokenExpired()) {
        await deleteFittingSize(id).then((res) => {
            const updatedFittingSizes = getState().FittingSizes.FittingSize.filter((item) => item.id !== id);
            dispatch(FittingSizeSlice.actions.receiveFittingSizes(updatedFittingSizes));
            dispatch(FittingSizeSlice.actions.success_({ 'sts': true, data: 'Connection Size deleted Successfully' }));
        }).catch(err => {
            if (err?.response?.data?.message?.includes("access token")) {
                handleError(err.response.data.message);
                setTimeout(() => { return signOut(); }, 500);
            } else {
                let msg = ''
                if (err?.response?.data?.data?.constraint?.includes("FK")) {
                    msg = 'Connection Size not deleted,It is being used in connection type'
                } else {
                    msg = err?.response?.data?.msg
                }
                dispatch(FittingSizeSlice.actions.success_({ 'sts': false, data: msg }));
            }
        })
    } else {
        handleError('Token is expired');
        setTimeout(() => { return signOut(); }, 500);
    }
}
export const updateSts = (data: any): any => async (dispatch: AppDispatch, getState: () => AppState) => {
    dispatch(FittingSizeSlice.actions.success_(data));
}

export default FittingSizeSlice.reducer;
